var _desc, _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1530,
    height: 2136,
    viewBox: "0 0 1530 2136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 23",
    cx: 1365,
    cy: 1624,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 21",
    cx: 1389.75,
    cy: 1624,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    cx: 1414.5,
    cy: 1624,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    cx: 1439.25,
    cy: 1624,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 1464,
    cy: 1624,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 25",
    cx: 1365,
    cy: 1648.75,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 26",
    cx: 1389.75,
    cy: 1648.75,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 24",
    cx: 1414.5,
    cy: 1648.75,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 1439.25,
    cy: 1648.75,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 1464,
    cy: 1648.75,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29",
    cx: 1365,
    cy: 1673.5,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 30",
    cx: 1389.75,
    cy: 1673.5,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28",
    cx: 1414.5,
    cy: 1673.5,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 1439.25,
    cy: 1673.5,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 1464,
    cy: 1673.5,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 1365,
    cy: 1698.25,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 1389.75,
    cy: 1698.25,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    cx: 1414.5,
    cy: 1698.25,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 1439.25,
    cy: 1698.25,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 1464,
    cy: 1698.25,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 1365,
    cy: 1723,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 1389.75,
    cy: 1723,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    cx: 1414.5,
    cy: 1723,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 1439.25,
    cy: 1723,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 1464,
    cy: 1723,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 23",
    cx: 28,
    cy: 2035,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 21",
    cx: 52.75,
    cy: 2035,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    cx: 77.5,
    cy: 2035,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    cx: 102.25,
    cy: 2035,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 127,
    cy: 2035,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 25",
    cx: 28,
    cy: 2059.75,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 26",
    cx: 52.75,
    cy: 2059.75,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 24",
    cx: 77.5,
    cy: 2059.75,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 102.25,
    cy: 2059.75,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 127,
    cy: 2059.75,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29",
    cx: 28,
    cy: 2084.5,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 30",
    cx: 52.75,
    cy: 2084.5,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28",
    cx: 77.5,
    cy: 2084.5,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 102.25,
    cy: 2084.5,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 127,
    cy: 2084.5,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 28,
    cy: 2109.25,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 52.75,
    cy: 2109.25,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    cx: 77.5,
    cy: 2109.25,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 102.25,
    cy: 2109.25,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 127,
    cy: 2109.25,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 28,
    cy: 2134,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 52.75,
    cy: 2134,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    cx: 77.5,
    cy: 2134,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 102.25,
    cy: 2134,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 127,
    cy: 2134,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 23",
    cx: 33,
    cy: 285,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 21",
    cx: 37,
    cy: 285,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    cx: 41,
    cy: 285,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    cx: 45,
    cy: 285,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 49,
    cy: 285,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 25",
    cx: 33,
    cy: 305,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 26",
    cx: 37,
    cy: 305,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 24",
    cx: 41,
    cy: 305,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 45,
    cy: 305,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 49,
    cy: 305,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29",
    cx: 33,
    cy: 325,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 30",
    cx: 37,
    cy: 325,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28",
    cx: 41,
    cy: 325,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 45,
    cy: 325,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 49,
    cy: 325,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 33,
    cy: 345,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 37,
    cy: 345,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    cx: 41,
    cy: 345,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 45,
    cy: 345,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 49,
    cy: 345,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 33,
    cy: 365,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 37,
    cy: 365,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    cx: 41,
    cy: 365,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 45,
    cy: 365,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 49,
    cy: 365,
    r: 2,
    fill: "#ABB2BF",
    fillOpacity: 1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 25",
    x: 0.5,
    y: 1453.5,
    width: 154,
    height: 154,
    stroke: "#ABB2BF",
    strokeOpacity: 1,
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 25",
    x: 1375.5,
    y: 488.5,
    width: 154,
    height: 154,
    stroke: "#ABB2BF",
    strokeOpacity: 1,
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26",
    x: 1361.5,
    y: 0.5,
    width: 90,
    height: 90,
    stroke: "#ABB2BF",
    strokeOpacity: 1,
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.07a527a319a737c272c601b11e5020ae.svg";
export { ForwardRef as ReactComponent };